import { render, staticRenderFns } from "./AccountPurchases.vue?vue&type=template&id=f19e2d28&scoped=true&"
import script from "./AccountPurchases.vue?vue&type=script&lang=js&"
export * from "./AccountPurchases.vue?vue&type=script&lang=js&"
import style0 from "./AccountPurchases.vue?vue&type=style&index=0&id=f19e2d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19e2d28",
  null
  
)

export default component.exports